<app-link [to]="to" [externaloverride]="externalTo">
  <div class="-card-container">
    <h4>{{family}}</h4>
    <h3>{{title}}</h3>
    <ng-content></ng-content>
  </div>
</app-link>